import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { HelpPageCategory } from '../models/helpPageCategory';

const controller = 'helppage-categories';

// Trädet är litet, så alla kategorier hämtas i en sida. API:t sorterar själv i trädets ordning.
export const getAllHelpPageCategories = async (): Promise<{ data: HelpPageCategory[] }> => {
  const result = await AxiosInstance.get<PagedResult<HelpPageCategory>>(controller, { params: { pageIndex: 0, pageSize: 1000 } });
  return { data: result.data.results };
};

export const getHelpPageCategoryById = (id: number) => {
  return AxiosInstance.get<HelpPageCategory>(`${controller}/${id}`);
};

// POST svarar med bara id:t, så kategorin hämtas efteråt (sortOrder sätts av API:t).
export const createHelpPageCategory = async (data: {
  name: string;
  description: string | null;
  parentId: number | null;
}): Promise<{ data: HelpPageCategory }> => {
  const created = await AxiosInstance.post<number>(controller, data);
  return getHelpPageCategoryById(created.data);
};

// Byts föräldern lägger API:t kategorin sist bland de nya syskonen och bortser från sortOrder.
export const updateHelpPageCategory = (data: HelpPageCategory) => {
  return AxiosInstance.put(controller, data);
};

export const deleteHelpPageCategory = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};
